const normalizeBaseUrl = (url: string): string => url.replace(/\/+$/, "");
const normalizeApiBase = (url: string): string =>
  normalizeBaseUrl(url).replace(/\/api$/i, "");
const backendBaseUrl = normalizeApiBase(
  process.env.REACT_APP_API_URL || "http://localhost:8090/api",
);

export const resolveMediaUrl = (value?: string | null): string => {
  if (!value) return "";
  if (value.startsWith("data:") || value.startsWith("http")) return value;
  return `${backendBaseUrl}/assets/${value}`;
};

export const resolveMediaUrlWithApiFallback = (
  value?: string | null,
  apiBase?: string
): string => {
  const direct = resolveMediaUrl(value);
  if (!direct) return "";
  if (direct.startsWith("http") || direct.startsWith("data:")) return direct;
  if (apiBase) {
    return `${normalizeApiBase(apiBase)}/assets/${value}`;
  }
  return direct;
};

export const getFileName = (value?: string | null): string => {
  if (!value) return "";
  const source = value.split("?")[0];
  const parts = source.split("/");
  return parts[parts.length - 1] || source;
};

export const getFileExtension = (value?: string | null): string => {
  const fileName = getFileName(value).toLowerCase();
  const dotIndex = fileName.lastIndexOf(".");
  if (dotIndex < 0 || dotIndex === fileName.length - 1) return "";
  return fileName.substring(dotIndex + 1);
};

export const isImageFile = (value?: string | null): boolean => {
  const extension = getFileExtension(value);
  return ["jpg", "jpeg", "png", "gif", "webp", "svg", "bmp"].includes(
    extension,
  );
};

export const isPdfFile = (value?: string | null): boolean =>
  getFileExtension(value) === "pdf";
